import * as _ from 'lodash-es';
import { useEffect, useRef, useState } from 'react';
import listenToPostScroll, { getScrollContainer } from './listenToPostScroll';

// The name "Chrome" describes a visual design element, not the browser
// https://www.nngroup.com/articles/browser-and-gui-chrome/
const usePostChromeVisible = (
  { enabled }: { enabled: boolean } = { enabled: true },
) => {
  const [isVisible, setIsVisible] = useState(true);
  const prevScrollTop = useRef<number>(0);

  useEffect(() => {
    if (enabled) {
      const scrollContainer = getScrollContainer();
      prevScrollTop.current = scrollContainer?.scrollTop ?? 0;
      const listener = _.throttle(({ scrollTop }) => {
        if (scrollTop < 0 || scrollTop === prevScrollTop.current) {
          return;
        }

        const hasScrolledUp = scrollTop < prevScrollTop.current;
        if (hasScrolledUp) {
          const hasScrolledUpEnough = prevScrollTop.current - scrollTop >= 10;
          if (hasScrolledUpEnough) {
            setIsVisible(true);
          }
        } else {
          setIsVisible(false);
        }

        prevScrollTop.current = scrollTop;
      }, 200);
      const removeListener = listenToPostScroll(listener);
      return () => {
        removeListener();
        listener.cancel();
      };
    }

    setIsVisible(true);
    return undefined;
  }, [enabled]);

  return isVisible;
};

export default usePostChromeVisible;
